import { render, staticRenderFns } from "./ProposalListRow.vue?vue&type=template&id=7c0bc3ba&scoped=true&"
import script from "./ProposalListRow.vue?vue&type=script&lang=js&"
export * from "./ProposalListRow.vue?vue&type=script&lang=js&"
import style0 from "./ProposalListRow.vue?vue&type=style&index=0&id=7c0bc3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0bc3ba",
  null
  
)

export default component.exports